import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=4e178f3d&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=ts&"
export * from "./tag.vue?vue&type=script&lang=ts&"
import style0 from "./tag.vue?vue&type=style&index=0&id=4e178f3d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e178f3d",
  null
  
)

export default component.exports